export studentIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_students.svg';
export worldIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_world.svg';
export arrowRightIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon-arrow.svg';
export infoIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon-info-active.svg';
export contactIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon-contact-us.svg';



// WEBPACK FOOTER //
// ./app/helpers/icon-dictionary.js